import { GuardedDeletionService } from 'projects/orchestrator/src/lib/services/guarded-deletion.service';
import { Component, inject } from '@angular/core';
import { PipelineStandService } from '../proxy/operational/controllers';
import { PipelineStandProjectionPlanningOrchestratorService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PipelineStandCreateDto,

  PipelineStandUpdateDto,
} from '../proxy/operational/dtos/pipeline-stand';
import { GetPipelineStandProjectionListInputDto, PipelineStandProjectionDto, PipelineStandProjectionExcelDownloadDto } from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/pipeline-stands/models';
import { PIPELINESTAND_CONFIG, PIPELINESTAND_FIELDS } from './pipeline-stand.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-pipeline-stand',
  imports: [
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, PipelineStandService, ConfirmationService],
  templateUrl: './pipeline-stand.html',
  styleUrl: './pipeline-stand.scss',
})
export class PipelineStand extends BaseHierarchicalCrudComponent<
  PipelineStandProjectionDto,
  PipelineStandCreateDto,
  PipelineStandUpdateDto,
  PipelineStandProjectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  private readonly operationalService = inject(PipelineStandService);
  private readonly projectionOrchestratorService = inject(PipelineStandProjectionPlanningOrchestratorService);

  service = {
    create: (input: PipelineStandCreateDto) => this.operationalService.create(input),
    update: (id: number, input: PipelineStandUpdateDto) => this.operationalService.update(id, input),
    deleteByIds: ids => this.guardedDeletion.deleteByIds('pipeline-stands', ids),
    getList: (input: GetPipelineStandProjectionListInputDto) => this.projectionOrchestratorService.getList(input),
    getDownloadToken: () => this.projectionOrchestratorService.getDownloadToken(),
    getListAsExcelFile: (input: PipelineStandProjectionExcelDownloadDto) => this.projectionOrchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(this.projectionOrchestratorService, 'pipelineStandId'),
  };
  config = PIPELINESTAND_CONFIG;
  fields = PIPELINESTAND_FIELDS;

  protected prepareCreateDto(data: any): PipelineStandCreateDto {
    return {
      name: data.name,
      area: data.area,
      pipelinePropertyId: data.pipelinePropertyId,
      standReasonId: data.standReasonId,
      negotiationReasonId: data.negotiationReasonId,
    };
  }

  protected prepareUpdateDto(data: any, selected: PipelineStandProjectionDto): PipelineStandUpdateDto {
    return {
      name: data.name,
      area: data.area,
      pipelinePropertyId: data.pipelinePropertyId,
      standReasonId: data.standReasonId,
      negotiationReasonId: data.negotiationReasonId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PipelineStand';
  }
}
